// extracted by mini-css-extract-plugin
export default {"iconWrapper":"vwOtsyQkwejU6bXm3N3z9"};